import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Avatar from "@material-ui/core/Avatar";
import OnffBlock from "./OnffBlock";
import DeleteSweepIcon from "@material-ui/icons/DeleteSweep";
import DeletePop from "./DeletePop";
import Utils from "../../../utility";
import moment from "moment";
import { reportedUsersService } from "../../../services/index";
import ReviewContentBlock from "./ReviewContentBlock";
import Loader from "../../../common/components/tablesLoader";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    whiteSpace: "nowrap",
  },
  container: {
    maxHeight: "100%",
  },
  Card: {
    maxHeight: 20,
  },
  Avatar: {
    maxHeight: 25,
    maxWidth: 25,
  },

  link: {
    "& > * + *": {
      marginLeft: theme.spacing(51),
    },
  },
  Table: {
    "&:nth-of-type(odd)": {
      backgroundColor: "white",
    },
    "&:nth-of-type(even)": {
      backgroundColor: "red",
    },
  },
  Deleteicon: {
    color: "grey",
    "&:hover, &.Mui-focusVisible": { color: "#FF0027" },
  },
}));

export default function StickyHeadTable(props) {
  const preventDefault = (event) => event.preventDefault();
  const classes = useStyles();
  const [isLoading, setLoading] = React.useState(true);
  const [page, setPage] = React.useState(0);
  const [blockUser, setblockUser] = React.useState([]);
  const [blockCount, setBlockCount] = React.useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [sort, setSort] = React.useState(1);
  const [up, setUp] = React.useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    let data = {
      pageNum: page,
      perpage: blockCount,
      sorted: sort,
    };
    getblockUsers(data);
  }, [blockCount, sort]);

  const getblockUsers = async (data) => {
    let [error, blockUserRes] = await Utils.parseResponse(
      reportedUsersService.getblockUsersList(data)
    );
    if (error || !blockUserRes) return;
    setblockUser(blockUserRes?.blockedContent);
    setBlockCount(blockUserRes?.blockedCount);
    setLoading(false);
    // return blockUser;
  };
  const handleUp = () => {
    setUp(!up);
    // console.log(up,"up")
  };

  console.log(sort, "sort");
  return (
    <Paper elevation={0} className={classes.root}>
      <Card className={classes.Card}>
        <Typography
          className={classes.link}
          variant="h8"
          color="#001441"
        ></Typography>
      </Card>
      <TableContainer className={classes.container} id="category_scroll">
        <Table className={classes.Table}>
          <TableHead>
            <TableRow>
              <TableCell className="border-bottom"></TableCell>
              <TableCell align="left" id="Table-cell" className="padding-tab">
                User Name
              </TableCell>
              <TableCell align="left" id="Table-cell" className="padding-tab">
                Wallet ID
              </TableCell>
              <TableCell align="left" id="Table-cell" className="padding-tab">
              No. Of Report
              </TableCell>
              <TableCell align="left" id="Table-cell" className="padding-tab">
                Reported On{" "}
                {!up ? (
                  <img
                    src="/downArrow.svg"
                    onClick={() => {
                      setSort(-1);
                      handleUp();
                    }}
                  />
                ) : (
                  <img
                    src="/upArrow.svg"
                    alt="up"
                    onClick={() => {
                      setSort(1);
                      handleUp();
                    }}
                  />
                )}
              </TableCell>
              <TableCell align="left" id="Table-cell" className="padding-tab">
                Report Category
              </TableCell>
              <TableCell align="left" id="Table-cell" className="padding-tab">
                Reported Content
              </TableCell>
              {/* <TableCell align="center" id="Table-cell" className="padding-tab">
                Delete Entry
              </TableCell> */}
              <TableCell align="left" id="Table-cell" className="padding-tab">
                Unblock User
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody className="table-body">
            {isLoading ? (
              <TableRow>
                <TableCell style={{ border: "none" }} colspan={12}>
                  <div className="homePageLoader">
                    <Loader />
                  </div>
                </TableCell>
              </TableRow>
            ) : blockUser?.length !== 0 ? (
              blockUser
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  if (row.isBlocked === true && row.isDeleted === false)
                    return (
                      <TableRow className="table-row">
                        <TableCell align="left" className="Table-cell  ">
                          <img
                            style={{
                              width: 30,
                              height: 30,
                              borderRadius: "15px",
                            }}
                            src={row.contentOwner.photo || "/defaultprofile.png"}
                            alt=""
                          />
                        </TableCell>
                        <TableCell
                          align="left"
                          className="Table-cell userNameReported w-0 padding-tab"
                        >
                          <span className="reportedUserAlign">
                            {row.contentOwner.firstName}
                          </span>
                        </TableCell>
                        <TableCell
                          align="left"
                          className="Table-cell padding-tab"
                        >
                          <span className="reportedUserAlign">
                            {row.walletId || "-"}
                          </span>
                        </TableCell>
                        <TableCell
                          align="left"
                          className="Table-cell padding-tab"
                        >
                          <span className="reportedUserAlign">
                            {row.reportedBy.length}
                          </span>
                        </TableCell>
                        <TableCell
                          align="left"
                          className="Table-cell padding-tab"
                        >
                          <span className="reportedUserAlign">
                            {" "}
                            {moment(row.modifiedOn).format("DD-MM-YYYY")}
                          </span>
                        </TableCell>
                        <TableCell
                          align="left"
                          className="Table-cell padding-tab"
                        >
                          <span className="reportedUserAlign">
                            {row.reportedCategory || "-"}
                          </span>
                        </TableCell>
                        <TableCell
                          align="left"
                          className="Table-cell padding-tab"
                        >
                          <span className="contentAlign">
                            <ReviewContentBlock
                              user={props?.user}
                              review={row}
                              getblockUsers={getblockUsers}
                            />
                          </span>
                        </TableCell>
                        {/* <TableCell
                          align="center"
                          className="Table-cell padding-tab"
                        >
                          {" "}
                          <DeletePop
                            row={row}
                            getblockUsers={getblockUsers}
                          />{" "}
                        </TableCell> */}

                        <TableCell
                          align="center"
                          className="Table-cell padding-tab"
                        >
                          <OnffBlock
                            isLoading={props?.isLoading}
                            rows={row.contentOwner.userID}
                            getblockUsers={getblockUsers}
                          />
                        </TableCell>
                      </TableRow>
                    );
                })
            ) : (
              <TableRow>
                <TableCell style={{ border: "none" }} colspan={12}>
                  <div className="homeSellBuyTable">
                    <center>No data found</center>
                  </div>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        id="test"
        rowsPerPageOptions={[5, 10, 25, 100]}
        component="div"
        count={blockCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
